import React, { useEffect } from 'react';
import { Chart } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { abbreviateNumber } from '../utils/abbreviateNumber.js';
let myLineChart;

const LineChart = () => {
  const richLists = useSelector((state) => state.richLists);
  const { activeList } = richLists;

  const timeSeries = useSelector((state) => state.timeSeries);
  const { data, activeTimescale } = timeSeries;

  let chartRef = React.createRef();

  useEffect(() => {
    buildChart();
  });

  const buildChart = () => {
    const myChartRef = chartRef.current.getContext('2d');
    if (typeof myLineChart !== 'undefined') myLineChart.destroy();

    let chartData = data.find((x) => x.list === activeList);
    let filteredData = {};
    if (activeTimescale === '1 Year') {
      filteredData['years'] = chartData.years.slice(-2);
      filteredData['values'] = chartData.values.slice(-2);
    } else if (activeTimescale === '5 Years') {
      filteredData['years'] = chartData.years.slice(-5);
      filteredData['values'] = chartData.values.slice(-5);
    } else {
      filteredData['years'] = chartData.years;
      filteredData['values'] = chartData.values;
    }

    myLineChart = new Chart(myChartRef, {
      type: 'line',
      options: {
        legend: {
          display: false,
        },
        elements: {
          point: {
            radius: 0,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItems, data) {
              return '$' + abbreviateNumber(tooltipItems.yLabel);
            },
          },
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value, index, values) {
                  return '$' + abbreviateNumber(value);
                },
              },
            },
          ],
        },
        animation: false,
      },
      data: {
        labels: filteredData.years,
        datasets: [
          {
            label: 'Total Value (AUD)',
            data: filteredData.values,
            fill: false,
            backgroundColor: 'rgba(245, 158, 11)',
            borderColor: 'rgba(245, 158, 11)',
          },
        ],
      },
    });
  };

  return (
    <>
      <canvas
        height="440"
        width="1122"
        style={{ display: 'block', height: '220px', width: '516px' }}
        id="myChart"
        ref={chartRef}
      />
    </>
  );
};

export default LineChart;
